import fetch from 'isomorphic-fetch';
import { API2_URL ,ACTIVITY_GROUP_REQUEST, ACTIVITY_GROUP_SHOW, ACTIVITY_GROUP_FAIL } from "../store/config";
import { newNotification } from "./notifications";
import _ from 'lodash';
import {sessionService} from "redux-react-session";

/*Group List*/
export const activityGroupShow = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(activityGroupRequest());
				return fetch(`${API2_URL}/proigualdad/activities/groups?per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(activityGroupData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityGroupFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

const activityGroupData = (json) => {
	return {
		type: ACTIVITY_GROUP_SHOW,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
};

/*Group Request*/
const activityGroupRequest = () => {
	return {
		type: ACTIVITY_GROUP_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

/*Group Fail*/
const activityGroupFail = (error) => {
	return {
		type: ACTIVITY_GROUP_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/activity_groups.js